// extracted by mini-css-extract-plugin
export var copyableField = "_oz-4";
export var customerBadge = "_oz-0";
export var customerInfoTitle = "_oz-2";
export var details = "_oz-1";
export var dropdownContainer = "_oz-5";
export var dropdownImage = "_oz-6";
export var editAssigneeForm = "_oz-a";
export var editButton = "_oz-3";
export var email = "_oz-7";
export var hidden = "_oz-d";
export var input = "_oz-8";
export var saveButton = "_oz-b";
export var shopifyIcon = "_oz-c";
export var suggestionBadge = "_oz-e";
export var suggestionText = "_oz-f";
export var username = "_oz-9";